<div class="app-about-area pt-100 pb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="app-about-image">
                    <img src="../../../../../assets/img/products/nvestor-funding-bridge-loans.png" alt="image">
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="app-about-content">
                    <span class="sub-title">FOR FAST PURCHASE</span>
                    <h2>Short Term Bridge Loans</h2>
                    <p>Short-term financing for fast purchasing and investment properties with high leverage, competitive terms.</p>
                    <div class="row">
                        <div class="col">
                            <ul class="list">
                                <li>
                                    <div class="icon bg-3">
                                        <i class="ri-check-line"></i>
                                    </div>
                                    <h3>Property Types:</h3>
                                    <p>SFR(1-4) - Multifamily (20 Units)</p>
                                </li>
                                <li>
                                    <div class="icon bg-3">
                                        <i class="ri-check-line"></i>
                                    </div>
                                    <h3>Loan Amounts:</h3>
                                    <p>$200K - $5MM</p>
                                </li>
                            </ul>
                        </div>
                        <div class="col">
                            <ul class="list">
                                <li>
                                    <div class="icon bg-3">
                                        <i class="ri-check-line"></i>
                                    </div>
                                    <h3>Loan to Values:</h3>
                                    <p>Up to 75%</p>
                                </li>
                                <li>
                                    <div class="icon bg-3">
                                        <i class="ri-check-line"></i>
                                    </div>
                                    <h3>Loan Terms:</h3>
                                    <p>Up to 24 Months</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="btn-box">
                        <a routerLink="/exit-strategy" class="default-btn">Get A Fast Free Quote</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>